import React from "react"
import { Label } from "../vehicle/map/TrackingMapLegends"

const DispatchMapLegend = () => {
  return (
    <section className="vt-tracking-map-legends vt-dispatch-map-legends">
      <Label
        src="http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
        text="Today's Orders"
      />
      <Label
        style={{
          marginLeft: 2,
        }}
        src="https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi-dotless2_hdpi.png"
        text="Selected Orders"
      />
      <Label
        src="http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
        text="Previous Orders"
      />
    </section>
  )
}

export default DispatchMapLegend
